export default "/arrow.182bbe10-636e32.svg?svgr";